module.exports = __webpack_public_path__ + "media/vectors/term-bg-2-535f71f7.jpg";